import { Axios } from "./request";

const API_URL = "usersapi/v1/documents/";

export const DOCUMENTS_INFORMATION_API = {
  GetDocumentsInformation: () => {
    return Axios.get(`${API_URL}GetDocumentsInformation`);
  },
  AddDocumentsInformation: (body) => {
    return Axios.post(`${API_URL}AddDocumentsInformation`, body);
  },
  EditDocumentsInformation: (body) => {
    return Axios.put(`${API_URL}EditDocumentsInformation`, body);
  },
};
